import {OBSOLETE_REQUEST_ERROR} from '@pb/middleware-api';

import type {HandleError} from '@pb/middleware-api';
import type {Error} from 'src/openapi/admin/models/Error';

export const ERROR: Error = {
    error: 'INTERNAL_SERVER_ERROR',
    message: 'There was an issue with your request. Please try again.',
};

export const errorsHandler: HandleError = params => {
    const {responseData, response} = params;

    if (!response) {
        if (responseData && typeof responseData === 'object' && 'reason' in responseData
            && responseData.reason === OBSOLETE_REQUEST_ERROR.reason) {
            return Promise.reject<Error>({
                ...OBSOLETE_REQUEST_ERROR,
                error: OBSOLETE_REQUEST_ERROR.reason,
            });
        }

        return Promise.reject(responseData);
    }

    if (response && !response.ok) {
        if (response?.status && response?.status >= 500) {
            return Promise.reject(ERROR);
        }

        return Promise.reject(responseData);
    }

    return Promise.resolve(responseData);
};
